module.exports = __webpack_public_path__ + "img/no-data.ef03ac10.svg";